import { ref } from "vue";
import L from 'leaflet';

export const isMeasuring = ref(false); // 지도상 측위
export const measuringTarget = ref(null); // 측위 대상상
export const measuringLocations = ref([]); // 현재 측위 좌표
export const measuringLines = ref([]); // 전체 폴리곤
export const measuringTooltip = ref([]); // 현재 툴팁
export const measurements = ref([]);
export const totalDistance = ref(0); // 전체 거리
export const tempLine = ref(null); // 임시 선 (마우스 따라다님)
export const tempTooltip = ref(null); // 임시 말풍선

const removeLayerFromTarget = (layer, target) => {
  if (layer && target) {
    target.removeLayer(layer);
    return null;  // Successfully removed the layer
  }
  return layer;  // Return the layer as is if it's not removable
};

export const startMeasuring = (clear = false) => {
  if (clear) {
    clearMeasuring();
  } else {
    clearMeasuring();
    isMeasuring.value = true;
  }
};

export const startTargetMeasuring = (target) => {
  isMeasuring.value = true;
  measuringTarget.value = target.device_id;
  addPoint(L.latLng(target.latitude, target.longitude), target);
};

export const stopMeasuring = (target) => {
  // 임시 선과 툴팁을 안전하게 제거
  tempLine.value = removeLayerFromTarget(tempLine.value, target);
  tempTooltip.value = removeLayerFromTarget(tempTooltip.value, target);

  measuringTarget.value = null;
  isMeasuring.value = false;
};

export const clearMeasuring = (target) => {
  measurements.value = [];
  measuringLines.value.forEach((line) => removeLayerFromTarget(line, target));
  measuringLines.value = [];
  measuringLocations.value.forEach((marker) => removeLayerFromTarget(marker, target));
  measuringLocations.value = [];
  measuringTooltip.value.forEach((tooltip) => removeLayerFromTarget(tooltip, target));
  measuringTooltip.value = [];
  totalDistance.value = 0;
};

export const addPoint = (latlng, target) => {
  measuringLocations.value.push(latlng);

  if (measuringLocations.value.length > 1) {
    if (measuringLines.value.length > 0) removeLayerFromTarget(measuringLines.value[measuringLines.value.length - 1], target);
    measuringTooltip.value.forEach((tooltip) => 
        measuringLocations.value.includes(tooltip.getLatLng()) ? removeLayerFromTarget(tooltip, target) : ''
    );
    totalDistance.value = 0;

    for (let i = 1; i < measuringLocations.value.length; i++) {
      const prevPoint = measuringLocations.value[i - 1];
      const distance = target.distance(prevPoint, measuringLocations.value[i]);
      totalDistance.value += distance;

      let content = '';
      if (i === measuringLocations.value.length - 1) {
        if (distance > 1000) {
          content = `점 간 거리: ${(distance * 0.001).toFixed(2)}km<br>전체 거리: ${(totalDistance.value * 0.001).toFixed(2)}km`;
        } else if (totalDistance.value > 1000) {
          content = `점 간 거리: ${distance.toFixed(2)}m<br>전체 거리: ${(totalDistance.value * 0.001).toFixed(2)}km`;
        } else {
          content = `점 간 거리: ${distance.toFixed(2)}m<br>전체 거리: ${totalDistance.value.toFixed(2)}m`;
        }
      } else {
        if (distance > 1000) {
          content = `점 간 거리: ${(distance * 0.001).toFixed(2)}km`;
        } else {
          content = `점 간 거리: ${distance.toFixed(2)}m`;
        }
      }

      measuringTooltip.value.push(
        L.tooltip({ permanent: true, direction: "bottom" })
          .setContent(content)
          .setLatLng(measuringLocations.value[i])
          .addTo(target)
      );
    }

    measuringLines.value.push(L.polyline(measuringLocations.value, { color: "red" }).addTo(target));
  }
};

// 이 함수는 맵에서 마우스 움직임을 처리
export const handleMouseMove = (e, target) => {
  // state.map이 제대로 초기화되었는지 확인
  if (!target) return;
  if (!isMeasuring.value || measuringLocations.value.length === 0) return;

  const lastPoint = measuringLocations.value[measuringLocations.value.length - 1];
  const distance = target.distance(lastPoint, e.latlng);

  // 임시 선 업데이트
  if (!tempLine.value) {
    tempLine.value = L.polyline([lastPoint, e.latlng], { color: "blue", dashArray: "5,5" }).addTo(target);
  } else if (target.hasLayer(tempLine.value)) {
    tempLine.value.setLatLngs([lastPoint, e.latlng]);
  }

  // 임시 말풍선 업데이트
  if (!tempTooltip.value) {
    // 툴팁 생성
    tempTooltip.value = L.tooltip({
      direction: "top",
      offset: [0, -20],
    })
      .setLatLng(e.latlng) // 좌표 설정
      .setContent(
        `점 간 거리: ${distance.toFixed(2)}m<br>전체 거리: ${(totalDistance.value + distance).toFixed(2)}m`
      )
      .addTo(target); // 맵에 추가
  } else {
    // 툴팁 업데이트
    if (target.hasLayer(tempTooltip.value)) {
      tempTooltip.value
        .setContent(
          `점 간 거리: ${distance.toFixed(2)}m<br>전체 거리: ${(totalDistance.value + distance).toFixed(2)}m`
        )
        .setLatLng(e.latlng); // 좌표 갱신
    } else {
      // 툴팁이 누락되었을 경우 다시 추가
      tempTooltip.value.addTo(target);
    }
  }
};